/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
// import { Pagination } from "@mui/material";
import { useAtom, useAtomValue } from "jotai";
import MainLayout from "layout/MainLayout";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { placeListFirstReadDocument, placeListReadDocument } from "service/placeListService";
import { storeSearchCategory, storeSearchCity, storeSearchGu, storeSearchKeyword, storeSearchStart, storeSearchSubCategory } from "store/searchValue";

function PlaceList() {
    const searchCategory = useAtomValue(storeSearchCategory)
    const searchSubCategory = useAtomValue(storeSearchSubCategory)
    const searchCity = useAtomValue(storeSearchCity)
    const searchGu = useAtomValue(storeSearchGu)
    const searchKeyword = useAtomValue(storeSearchKeyword)
    const searchStart = useAtomValue(storeSearchStart)

    const [originPlaceList, setOriginPlaceList] = useState(new Array())
    const [placeList, setPlaceList] = useState(new Array())

    const [startAfter, setStartAfter] = useState<any>(null)

    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true)

    const { ref, inView } = useInView();

    useEffect(() => {
        init()
    }, [searchStart])

    useEffect(() => {
        if (inView && hasMore) {
            getFirebaseDocument();
        }
    }, [inView]);

    const init = async () => {

        setHasMore(true);
        setLoading(true);

        try {
            // 가져오기
            console.log("aaa")
            let querySnapshot = await placeListFirstReadDocument(
                "place", 
                "reg_time", 
                10
            )

            if (querySnapshot.empty) {
                setHasMore(false);
                setLoading(false);
                return;
            }

            // 변환
            let tmpMarkerList = new Array()
            querySnapshot.forEach((doc: any) => {
                tmpMarkerList.push(doc.data())
            });

            const newList = tmpMarkerList.filter((item) => (
                item.category.includes(searchCategory)
                && item.sub_category.includes(searchSubCategory)
                && item.addr1.includes(searchCity)
                && item.addr1.includes(searchGu)
                && (item.title.includes(searchKeyword) || item.info.addr1.includes(searchKeyword) )
            ))

            // setting
            setOriginPlaceList(tmpMarkerList)

            // @ts-ignore
            setPlaceList(newList)
            
            setStartAfter(querySnapshot.docs[querySnapshot.docs.length-1])
        } catch (error) {
            console.error("Error fetching posts: ", error);
        } finally {
            setLoading(false);
        }
    }

    const getFirebaseDocument = async () => {
        if (loading) return;

        setLoading(true);

        try {
            // 가져오기
            console.log("bbb")
            let querySnapshot = await placeListReadDocument(
                "place", 
                "reg_time", 
                startAfter, 
                10
            )

            if (querySnapshot.empty) {
                setHasMore(false);
                setLoading(false);
                return;
            }

            // 변환
            let tmpMarkerList = new Array()
            querySnapshot.forEach((doc: any) => {
                tmpMarkerList.push(doc.data())
            });

            const newList = tmpMarkerList.filter((item) => (
                item.category.includes(searchCategory)
                && item.sub_category.includes(searchSubCategory)
                && item.addr1.includes(searchCity)
                && item.addr1.includes(searchGu)
                && (item.title.includes(searchKeyword) || item.info.addr1.includes(searchKeyword) )
            ))

            // setting
            setOriginPlaceList((prev) => [...prev, ...tmpMarkerList])

            // @ts-ignore
            setPlaceList((prev) => [...prev, ...newList])

            setStartAfter(querySnapshot.docs[querySnapshot.docs.length-1])
        } catch (error) {
            console.error("Error fetching posts: ", error);
        } finally {
            setLoading(false);
        }
    }

    const settingImage = (info: any) => {
        let tmpImageSrc = require("../assets/images/baek_jong_won.png")
        if(info.category.includes("백종원")){
            tmpImageSrc = require("../assets/images/baek_jong_won.png")
        } else if(info.category.includes("성시경")){
            tmpImageSrc = require("../assets/images/seong_si_kyung.png")
        } else if(info.category.includes("먹보스")){
            tmpImageSrc = require("../assets/images/hyun_joo_yup.png")
        } else if(info.category.includes("최자")){
            tmpImageSrc = require("../assets/images/chioza.png")
        } else if(info.category.includes("풍자")){
            tmpImageSrc = require("../assets/images/pung_ja.png")
        }
        return tmpImageSrc
    }

    return(
        <MainLayout>
            <div css={MainWrapperStyle} style={{height: window.innerHeight - 120 + 'px'}}>
                {placeList.map((item: any, index: number) => (
                    <div css={CardWrapperStyle} key={index}>
                        <div css={CardImageWrapperStyle}>
                            <img src={item?.image_url ? item?.image_url : settingImage(item)} alt="test" css={CardImageStyle} loading="lazy"></img>
                        </div>
                        <div css={CardInfoWrapperStyle}>
                            <div css={CategoryInfoStyle}>
                                {item.category}
                            </div>
                            <div css={TitleInfoStyle}>
                                {item.title}
                            </div>
                            <div css={AddressInfoStyle}>
                                {`(${item.addr1})`}
                            </div>
                            <div css={PhoneInfoStyle}>
                                {item.phone}
                            </div>
                            <div css={MenuInfoStyle}>
                                {item.menu}
                            </div>
                        </div>
                    </div>
                ))}

                <div ref={ref} />
                {/* <Pagination count={10} /> */}
            </div>
        </MainLayout>
    )
    
}

const MainWrapperStyle = css`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background: #f4f4f4;
    padding: 14px;
    display: flex;
    flex-wrap: wrap;
    gap: 30px;

    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */

    &::-webkit-scrollbar {
        display: none; /* for Chrome, Safari, and Opera */
    }
    /* justify-content: space-between; */
`

const CardWrapperStyle = css`
    overflow: hidden;
    flex: 0 0 auto;
    width: calc((100% / 2) - 17.5px);
    /* margin-bottom: 20px; */
`

const CardImageWrapperStyle = css`
    width: 100%;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
`

const CardImageStyle = css`
    width: 100%;
    /* object-fit: cover; */
    height: 150px;
`

const CardInfoWrapperStyle = css`
    background: #fff;
    padding: 17.5px;
    height: 160px;
    overflow: hidden;
`

const CategoryInfoStyle = css`
    font-size: 13.1px;
    color: #333;
`

const TitleInfoStyle = css`
    font-size: 17.5px;
    color: #111;
    font-weight: 700;
    line-height: 1.3;
    word-break: keep-all;
    margin-top: 4.4px;
`

const AddressInfoStyle = css`
    font-size: 15.4px;
    color: #111;
    font-weight: 700;
`

const PhoneInfoStyle = css`
    font-size: 15.4px;
    color: #289997;
    margin-top: 4.4px;
`

const MenuInfoStyle = css`
    font-size: 12.3px;
    color: #111;
    font-weight: 300;
    line-height: 1.3;
    word-break: keep-all;
    margin-top: 4.4px;
`

export default PlaceList;